import { createFileRoute } from "@tanstack/react-router";

import { Checklist } from "@/components/documentos/checklist";

// Los estados de cuenta: uno por cuenta y por mes, cada uno atado a una razón
// social. La pantalla es un CHECKLIST y no un tablero por etapas, porque la
// pregunta del mes no es «¿qué pasó con lo que subí?» sino «¿me falta alguno?».
export const Route = createFileRoute("/_app/documentos/estados-de-cuenta")({
  component: Checklist,
});
